import React from 'react'

class Back extends React.Component {
  render() {
    return (
      <a className='smaller' href='#' onClick={this.props.onGoBack}>Back</a>
    )
  }
}

export default Back;
